import React, { Component } from 'react';
import PropTypes from "prop-types";
import PublicSpaceCardDetailsGoogleMapView from "./PublicSpaceCardDetailsGoogleMapView";
import ImageCarouselView from "./ImageCarouselView";
import EventPublisher from "../../utils/EventPublisher";
import UIInteractionEvents from "../../constants/events/UIInteractionEvents";
import Money from "../../utils/Money";


export default class PublicSpaceCardDetailsView extends Component {

    static propTypes = {
        spaceId: PropTypes.number.isRequired,
        title: PropTypes.string.isRequired,
        description: PropTypes.string.isRequired,
        pricePerDay: PropTypes.number.isRequired,
        minimumDays: PropTypes.number.isRequired,
        distance: PropTypes.number.isRequired,
        created: PropTypes.number.isRequired,
        longitude: PropTypes.number.isRequired,
        latitude: PropTypes.number.isRequired,
        imageNames: PropTypes.arrayOf(PropTypes.string).isRequired,
        status: PropTypes.string.isRequired,
    };

    render() {
        return (
            <div className="card mb-2">
                <div className="card-body">
                    <div className="row">
                        <div className="col-md-10 col-sm-6 col-12">
                            <h2 className="card-title">{this.props.title}</h2>
                        </div>
                        <div className="col-md-2 col-sm-6 col-12 text-right">
                            <div>
                                <h4>
                                    {Money.formatMoney(this.props.pricePerDay)} per day
                                </h4>
                            </div>
                            <div>
                                <h5>
                                    minimum {this.props.minimumDays} days
                                </h5>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-8">
                            <ImageCarouselView id={this.props.spaceId} imageNames={this.props.imageNames} imageClassName="card-img-view-space"/>
                        </div>
                        {this._renderReserveSpace()}
                    </div>
                    <div className="card-body" id={this.props.spaceId}>
                        <h4>Description</h4>
                        {this.renderDescription()}
                        <h4>Location</h4>
                        <PublicSpaceCardDetailsGoogleMapView
                            latitude={this.props.latitude}
                            longitude={this.props.longitude}/>
                    </div>
                </div>
            </div>
        );
    }

    renderDescription() {
        const descriptionParagraphs =
            this.props.description.split(/\r?\n/)
                .map(this.convertSpacesToBlankLine)
                .filter(this.isFirstOrNotSuccessiveEmptyParagraph)
                .reduce(this.mergeBrSeparated, [])
                .map(this.convertToHTML);
        return (
            <div className="card-text p-3 bg-white rounded mb-2">
                {descriptionParagraphs}
            </div>
        );
    }

    mergeBrSeparated(accumulator, currentValue, currentIndex, all) {
        if (currentIndex !== 0 && all[currentIndex-1] !== "") {
            const previousValue = accumulator.pop();
            accumulator.push(
                <React.Fragment key={"fl-"+currentIndex}>
                    {previousValue}
                    <br/>
                    {currentValue}
                </React.Fragment>
            );
            return accumulator;
        }
        accumulator.push(currentValue);
        return accumulator;
    }

    convertToHTML(line, currentIndex, all) {
        if (line === "") {
            return null;
        }
        return (<p key={"pl-"+currentIndex}>{line}</p>);
    }

    convertSpacesToBlankLine(line) {
        if (line.match(/^[\s]*$/g)) {
            return "";
        }
        return line;
    }

    isFirstOrNotSuccessiveEmptyParagraph(line, index, all) {
        if (index === 0) {
            return true;
        }
        return !(line === "" && all[index - 1] === "");
    }

    _renderReserveSpace() {
        if (this.props.status === "UNLISTED") {
            return (
                <div className="col-md-4 text-center align-self-center mt-sm-3">
                    <div className="alert alert-danger" role="alert">
                        Space Is currently unavailable
                    </div>
                </div>);
        }
        return (
            <div className="col-md-4 text-center align-self-center mt-sm-3">
                <button className="btn btn-lg btn-secondary" onClick={this.handleLoginClick}>Reserve This Space</button>
            </div>
        );
    }

    handleLoginClick = () => {
        EventPublisher.publish(UIInteractionEvents.PUBLIC_NAV_LOGIN_BUTTON_CLICKED, {});
    };
}

